module.exports = __webpack_public_path__ + "img/1.cee6dce2.jpg";